import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';
import { AppComponent } from '../../../app.component';
import { Service } from '../../../services';
import { GlobalService } from '../../../global.service';
import { LoadingScreenService } from '../../../services/loading-screen/loading-screen.service';

@Component({
    selector: 'app-lineonly-faultreport',
    templateUrl: './lineonly.component.html',
    styleUrls: ['./lineonly.component.sass']
})
export class LineonlyComponent implements OnInit {
    @Input() index;
    @Input() typeOfBreakdown;
    @Input() subscriber;
    @Input() productType;
    @Input() screenView;
    @Input() selectBan;
    @Output() updateScreenView = new EventEmitter<any>();
    @Output() respuesta = new EventEmitter<any>();

    public nroContrato1 = "";
    public typeOfFault = "";
    public detalle = "";
    public nroContrato2 = "";
    public accountType;
    public accountSubtype;
    public subscribernumber;
    public token: string = sessionStorage.getItem("token");
    constructor(private router: Router, public appComponent: AppComponent, private services: Service, private global: GlobalService, private loadingScreenService: LoadingScreenService) { }

    ngOnInit() {
        if (this.global.validateSession() == true) {
            this.accountType = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountTypeField;
            this.accountSubtype = JSON.parse(atob(sessionStorage.getItem("getAccountDetails"))).AccounInfo.accountSubtypeField;
        }
        
    }
    report() {
        this.sendReport(this.index, this.subscribernumber, this.productType);
    }
    sendReport(index, subscriber, productType) {
        let detailOptions = '';
        let typeOfFault = '';
        if (this.global.validateSession() === true) {
            var ruido = document.getElementById("ruido_" + index) as HTMLInputElement;
            var sinTono = document.getElementById("sin_tono_" + index) as HTMLInputElement;
            if (ruido.checked == true || sinTono.checked == true) {
                if (ruido.checked == true) {
                    if (this.typeOfBreakdown == "LINE") {
                        this.typeOfFault = "Ruido";
                        detailOptions = '|LINE';
                        typeOfFault = 'NOISE';
                    }
                    else {
                        this.typeOfBreakdown = "Línea + DSL";
                        this.typeOfFault = "Sin internet y con Voz";
                        detailOptions = '|NO_INTERNET_WITH_VOICE';
                        typeOfFault = 'LINE|DSL';
                    }
                }
                else {
                    if (this.typeOfBreakdown == "LINE") {
                        this.typeOfFault = "Sin Tono";
                        detailOptions = '|TONELESS';
                        typeOfFault = 'LINE';
                    }
                    else {
                        this.typeOfBreakdown = "Línea + DSL";
                        detailOptions = '|NO_INTERNET_NO_VOICE';
                        typeOfFault = 'LINE|DSL';
                    }
                }
                typeOfFault=typeOfFault+detailOptions;
               // typeOfFault="1";
                if (this.nroContrato1 != "") {
                    if (this.detalle != "") {
                        this.loadingScreenService.startLoading();
                       // this.services.RaiseIssueTicket("7878050326", "806830900", this.nroContrato1, this.nroContrato2, typeOfFault, 1, sessionStorage.getItem("name"), this.detalle, 1)
                        this.services.RaiseIssueTicket(this.subscriber, this.selectBan, this.nroContrato1, this.nroContrato2, typeOfFault, 1, sessionStorage.getItem("name"), this.detalle, this.productType)
                            .subscribe(data => {
                                this.loadingScreenService.stopLoading();
                                if (data.hasError == false) {
                                    this.respuesta.emit([data.result[0].tt_id, data.result[0].commitmentDate,this.typeOfBreakdown,this.subscriber]);
                                    this.screenView[index] = 3;
                                    this.updateScreenView.emit(this.screenView);
                                }
                                else {
                                    this.global.notif(data.errorDesc);
                                }
                            });
                    }
                    else {
                        this.global.notif('Debe de ingresar una breve explicación de lo que desea reportar.');
                    }
                }
                else {
                    this.global.notif('Debe colocar el número de contrato.');
                }
            }
            else {
                this.global.notif('Por favor, especifique el tipo de avería que desea reportar.');
            }
        }
    }
    back(index) {
        if (this.global.validateSession() === true) {
            this.screenView[index] = 1;
            this.updateScreenView.emit(this.screenView);
        }
    }

}
